export const AVATAR_SIZE = 48;
export const DEFAULT_AVATAR = 'https://www.mycarforum.com/public/style_images/master/profile/default_large.png';
